import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { NoticeBody } from "@/pages/NoticeView";
import { Printer } from "lucide-react";
import { printWithTitle } from "@/lib/printWithTitle";

export default function PublicNotice() {
  const { shareToken } = useParams();
  const [n, setN] = useState(null);
  const [labels, setLabels] = useState({});
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get("/catalog/notice-templates").then(({ data }) => setLabels(data.impact_labels));
    api.get(`/notices/public/${shareToken}`).then(({ data }) => setN(data)).catch(() => setErr(true));
  }, [shareToken]);

  // Dynamic browser/PDF document title — also used as default PDF filename.
  useEffect(() => {
    if (!n) return;
    const label = (n.site_name || n.title || "").trim();
    const prev = document.title;
    document.title = label ? `Asukastiedote - ${label}` : "Asukastiedote";
    return () => { document.title = prev; };
  }, [n]);

  const onPrint = () => {
    const label = (n?.site_name || n?.title || "").trim();
    printWithTitle(label ? `Asukastiedote - ${label}` : "Asukastiedote");
  };

  if (err) return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="font-display text-xl text-slate-900">Tiedotetta ei löytynyt</div>
        <p className="text-slate-500 mt-2">Linkki on vanhentunut tai virheellinen.</p>
      </div>
    </div>
  );
  if (!n) return <div className="min-h-screen flex items-center justify-center text-slate-500">Ladataan...</div>;

  return (
    <div className="min-h-screen bg-slate-100">
      <div className="print-hide max-w-4xl mx-auto px-5 md:px-8 pt-6 flex flex-col items-end gap-1.5">
        <button onClick={onPrint} className="btn-primary text-sm" data-testid="public-notice-print">
          <Printer className="h-4 w-4" /> Tulosta / Tallenna PDF
        </button>
        <p className="text-[11px] text-slate-500 max-w-xs text-right leading-snug">
          Vihje: jos selaimen päivämäärä tai osoite näkyy tulosteessa, poista valinta
          <em> "Otsikot ja alatunnisteet"</em> tulostusvalintojen lisäasetuksista.
        </p>
      </div>
      <div className="py-6 px-3 md:px-8 print-page">
        <NoticeBody n={n} labels={labels} />
      </div>
    </div>
  );
}
